import { reactive } from "vue";

export const store = reactive({
	navBarHeight: 0,
	navDrawerOpen: false,
	floatyNavEnabled: true,
});

export const mutations = {
	changeNavBarHeight(newHeight) {
		store.navBarHeight = newHeight;
	},
	toggleNavDrawer() {
		store.navDrawerOpen = !store.navDrawerOpen;
	},
	closeNavDrawer() {
		store.navDrawerOpen = false;
	},
	openNavDrawer() {
		store.navDrawerOpen = true;
	},
	enableFloatyNav() {
		store.floatyNavEnabled = true;
	},
	disableFloatyNav() {
		store.floatyNavEnabled = false;
	},
};
